// extracted by mini-css-extract-plugin
export default {"payment_modal":"choosePlans_payment_modal__q18iN"};